export default [
  {
    path: '/home',
    name: 'hotelpage',
    view: 'HotelPage'
  },
  {
    path: '/room/:id',
    name: 'roompage',
    view: 'RoomPage'
  },
  {
    path: '/devices/tv',
    name: 'deviceTV',
    view: 'DeviceTV'
  },
  {
    path: '/room/:id/scenario',
    name: 'scenariopage',
    view: 'AddScenario'
  },
  {
    path: '/controller/:id',
    name: 'controllerpage',
    view: 'ControllerPage'
  },
  {
    path: '/debug_controller/:id',
    name: 'debugcontrollerpage',
    view: 'DebugControllerPage'
  },
  {
    path: '/room/:id/device',
    name: 'devicepage',
    view: 'DevicePage'
  },
];
